/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'
import './index.css'
import open_in_browser from './img/open_in_browser.png'
import worker_download from './img/worker_download.png'
import { getAppApk } from '@api/app-apk.api';
export default function DownloadApp() {
    const [appVersion, setAppVersion] = useState('')

    async function getAppApkData() {
        let res = await getAppApk();
        setAppVersion(res.data.version)
        return res.data.version;
    }
    function go2DownloadIos() {
        // eslint-disable-next-line no-restricted-globals
        location.href = "https://itunes.apple.com/cn/app/qq/id1093735457";
    }
    async function go2DownloadAndroid() {
        window.location.href = `https://a.app.qq.com/o/simple.jsp?pkgname=conn.worker.yi_qizhuang`
        // if (!appVersion) {
        //     const version = await getAppApkData()
        //     window.location.href = `https://media.1qizhuang.com/app_apk/yiqizhuang-${version}.apk`
        // } else {
        //     window.location.href = `https://media.1qizhuang.com/app_apk/yiqizhuang-${appVersion}.apk`
        // }
    }
    let isDisplay = 'none'
    let ua: any = navigator.userAgent
    let isWx = /MicroMessenger/.test(ua)
    let isAndroid = /Android/.test(ua)
    let isIOS = /(iPhone|iPad)/.test(ua)

    if (isWx) {
        if (!isIOS) {
            //如果是android,提示在浏览器打开
            isDisplay = 'block';
        } else {
            //如果是ios,提示在浏览器打开
            go2DownloadIos();
        }
    } else {
        //如果不在微信里面,显示logo和下载按钮
        //如果能区分android或者ios,则自动下载
        if (isIOS) {
            go2DownloadIos();
        } else {
            go2DownloadAndroid();
        }
    }
    return (
        <div id="wrapper">
            <div id="openInBrowser" style={{ display: isDisplay }}>
                <img src={open_in_browser} alt="open_in_browser" style={{ position: 'relative', width: '100%', height: 'auto' }} />
            </div>
            <div id="downloadIntroduce" className="worker">
                <img src={worker_download} alt="download" />
                <button id="iosBtn" onClick={() => go2DownloadIos()}>下载iOS版本</button>
                <button id="androidBtn" onClick={() => go2DownloadAndroid()} >下载Android版</button>
                <span>已下载APP？快去打开APP使用吧~</span>
            </div>
            <div id="footerContainer">
                <footer>丁满信息科技（上海）有限公司</footer>
            </div>
        </div>
    )
}
